/**
 * 變數值檢測模組
 */
export class Dummy {
  stringEmpty = ['', null, undefined];
  numberEmpty = [undefined, NaN];
  amountEmpty = ['', null, undefined, NaN, '0.0'];
}
/**
 * 字串是否為空
 * @param thisString 欲檢核字串
 * @returns boolean
 */
const dummy = new Dummy();
const checkStringIsempty = (thisString: string): boolean => {
  return dummy.stringEmpty.includes(thisString);
};
/**
 * 數字是否為空
 * @param thisNumber 欲檢核數字
 * @returns boolean
 */
const checkNumberIsempty = (thisNumber: number): boolean => {
  return dummy.numberEmpty.includes(thisNumber);
};
/**
 * 變數/金額數字是否為空
 * @param thisVariable 欲檢核變數
 * @returns boolean
 */
const checkVariableIsempty = (thisVariable: any): boolean => {
  return dummy.amountEmpty.includes(thisVariable);
};
/**
 * 確認是否為數字加小數點（金額）
 * @param val
 * @returns boolean
 */
const checkOnlyNumberAndDot = (val: string) => {
  if (val && typeof val === 'string') {
    const rule = new RegExp(/[^0-9.]/g);
    if (rule.test(val)) {
      return false;
    }
  }

  return true;
};
export {
  checkNumberIsempty,
  checkOnlyNumberAndDot,
  checkStringIsempty,
  checkVariableIsempty,
};
